import * as Common from '@/tenant/common';

export class StockRelocationItem extends Common.StateObject2{
  constructor(){
    super('StockRelocationItem');
    this.binders.stockRelocation = new Common.ModelBinder(Common.StockRelocation);
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.sku = new Common.ModelBinder(Common.SKU);
    // this.workflowCode="stockRelocationItem";
    this.state = StockRelocationItemStatus.StockRelocationWaiting;
    // this.workflowStateId = StockRelocationItemStatus.StockRelocationWaiting;

    //this.transferIn = new StockRelocationReserveItems(this,true);
    //this.transferOut = new StockRelocationReserveItems(this,false);    
  }

  public id: number = 0;
  public stockRelocationNo: string = '';
  public stockRelocation: Common.StockRelocation = null;
  public seqNo: number = 0;
  public stockRelocationItemNo: string = '';
  public commodityId: number = 0;
  public commodity: Common.Commodity = null;
  public skuId: number = null;
  public sku: Common.SKU = null;
  public quantity: number = 0;
  //案件
  public projectItemNo : string = null;
  public projectItem : Common.ProjectItem = null;  
  // public get workflowHolder():string{
  //   return this.stockRelocation ? this.stockRelocation.workflowHolder: super.workflowHolder;
  // }
  // public set workflowHolder(value:string){
  //   super.workflowHolder = value;
  // }
  //出庫側予備項目
  public reserveText1Out: string = '';
  public reserveText2Out: string = '';
  public reserveText3Out: string = '';
  public reserveText4Out: string = '';
  public reserveText5Out: string = '';
  public reserveText6Out: string = '';
  public reserveMemo1Out: string = '';
  public reserveMemo2Out: string = '';
  public reserveMemo3Out: string = '';
  public reserveDate1Out: Date = null;
  public reserveDate2Out: Date = null;
  public reserveDate3Out: Date = null;
  public reserveList1Out: number = null;
  public reserveList2Out: number = null;
  public reserveList3Out: number = null;

  //入庫側予備項目
  public reserveText1In: string = '';
  public reserveText2In: string = '';
  public reserveText3In: string = '';
  public reserveText4In: string = '';
  public reserveText5In: string = '';
  public reserveText6In: string = '';
  public reserveMemo1In: string = '';
  public reserveMemo2In: string = '';
  public reserveMemo3In: string = '';
  public reserveDate1In: Date = null;
  public reserveDate2In: Date = null;
  public reserveDate3In: Date = null;
  public reserveList1In: number = null;
  public reserveList2In: number = null;
  public reserveList3In: number = null;

  //クローンした時に親がコピーされるのでフィールドにはしない
  public get transferIn()  {return new StockRelocationReserveItems(this,true);}
  public get transferOut() {return new StockRelocationReserveItems(this,false);}

}

/**片側バインド用 */
export class StockRelocationReserveItems
{
    constructor(item: StockRelocationItem, isIn : boolean){
      this.item = item;
      this.isIn = isIn;
    }
  public isIn:boolean = false;
  public item: StockRelocationItem;
  public get reserveText1(): string {return this.isIn ? this.item.reserveText1In: this.item.reserveText1Out;}
  public get reserveText2(): string {return this.isIn ? this.item.reserveText2In: this.item.reserveText2Out;}
  public get reserveText3(): string {return this.isIn ? this.item.reserveText3In: this.item.reserveText3Out;}
  public get reserveText4(): string {return this.isIn ? this.item.reserveText4In: this.item.reserveText4Out;}
  public get reserveText5(): string {return this.isIn ? this.item.reserveText5In: this.item.reserveText5Out;}
  public get reserveText6(): string {return this.isIn ? this.item.reserveText6In: this.item.reserveText6Out;}      
  public get reserveMemo1(): string {return this.isIn ? this.item.reserveMemo1In: this.item.reserveMemo1Out;}  
  public get reserveMemo2(): string {return this.isIn ? this.item.reserveMemo2In: this.item.reserveMemo2Out;}  
  public get reserveMemo3(): string {return this.isIn ? this.item.reserveMemo3In: this.item.reserveMemo3Out;}  
  public get reserveDate1(): Date {return this.isIn ? this.item.reserveDate1In: this.item.reserveDate1Out;}  
  public get reserveDate2(): Date {return this.isIn ? this.item.reserveDate2In: this.item.reserveDate2Out;}  
  public get reserveDate3(): Date {return this.isIn ? this.item.reserveDate3In: this.item.reserveDate3Out;}    
  public get reserveList1(): number {return this.isIn ? this.item.reserveList1In: this.item.reserveList1Out;}  
  public get reserveList2(): number {return this.isIn ? this.item.reserveList2In: this.item.reserveList2Out;}  
  public get reserveList3(): number {return this.isIn ? this.item.reserveList3In: this.item.reserveList3Out;}  

  public set reserveText1(value :string)  {if (this.isIn) {this.item.reserveText1In = value; } else {this.item.reserveText1Out = value;}}
  public set reserveText2(value :string)  {if (this.isIn) {this.item.reserveText2In = value; } else {this.item.reserveText2Out = value;}}
  public set reserveText3(value :string)  {if (this.isIn) {this.item.reserveText3In = value; } else {this.item.reserveText3Out = value;}} 
  public set reserveText4(value :string)  {if (this.isIn) {this.item.reserveText4In = value; } else {this.item.reserveText4Out = value;}} 
  public set reserveText5(value :string)  {if (this.isIn) {this.item.reserveText5In = value; } else {this.item.reserveText5Out = value;}} 
  public set reserveText6(value :string)  {if (this.isIn) {this.item.reserveText6In = value; } else {this.item.reserveText6Out = value;}} 
  public set reserveMemo1(value :string)  {if (this.isIn) {this.item.reserveMemo1In = value; } else {this.item.reserveMemo1Out = value;}}
  public set reserveMemo2(value :string)  {if (this.isIn) {this.item.reserveMemo2In = value; } else {this.item.reserveMemo2Out = value;}}
  public set reserveMemo3(value :string)  {if (this.isIn) {this.item.reserveMemo3In = value; } else {this.item.reserveMemo3Out = value;}}
  public set reserveDate1(value :Date)  {if (this.isIn) {this.item.reserveDate1In = value; } else {this.item.reserveDate1Out = value;}}
  public set reserveDate2(value :Date)  {if (this.isIn) {this.item.reserveDate2In = value; } else {this.item.reserveDate2Out = value;}}
  public set reserveDate3(value :Date)  {if (this.isIn) {this.item.reserveDate3In = value; } else {this.item.reserveDate3Out = value;}}
  public set reserveList1(value :number)  {if (this.isIn) {this.item.reserveList1In = value; } else {this.item.reserveList1Out = value;}}
  public set reserveList2(value :number)  {if (this.isIn) {this.item.reserveList2In = value; } else {this.item.reserveList2Out = value;}}
  public set reserveList3(value :number)  {if (this.isIn) {this.item.reserveList3In = value; } else {this.item.reserveList3Out = value;}}

}
export enum StockRelocationItemStatus
{
  StockRelocationWaiting = 1, // 確定待ち
  Completed = 2, // 完了
  Instruction = 4 // 移動指示中
}

export class StockRelocationItemQuery extends Common.LoadQuery {
  constructor(){
    super('StockRelocationItemQuery',StockRelocationItem);
    this.sort = 'stockRelocationItemNo';
  }

  public segment: Common.Segment = null;
  public warehouseOut: Common.Counterpart = null;
  public warehouseIn: Common.Counterpart = null;
  public pic: string = '';
  public stockRelocationNo: string = '';
  public stockRelocationItemNo: string = '';
  public refNo: string = '';
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public commodity: Common.Commodity = null;
  public sku :Common.SKU = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.StockRelocationItemStatus = Common.StockRelocationItemStatus.StockRelocationWaiting;
  public holder: string = '';
}